import React from 'react';
import GOTUtil from '../../utils/GOTUtil';
import FormLoadHelper from '../../utils/FormLoadHelper';
import Command from '../../remote/Command';
import ServiceHelper from '../../remote/ServiceHelper';
require('./style/TreeViewMainMenuStyle.css');
export default class TreeViewMainMenu extends React.Component
{
	constructor(props)
	{
		super(props);
		this.renderSub=this.renderSub.bind(this);
		this.menuItemClick = this.menuItemClick.bind(this);
		this.getLabelName=this.getLabelName.bind(this);
		this.platMainMenu = {};
	}

	//dbclick
	menuItemClick(event)
	{		
		this.doOpenMenuItem(event);
		//window.testOpenForm(_label,_formId,_menuItemId,_onlyQuery);
	}

	doOpenMenuItem(event)
	{
		var target = event.target;
		if(!$(target).parent().hasClass("treeview menuItem"))
		{
			target = $(target).parent();
		}

		if(!$(target).parent().hasClass("treeview menuItem"))
		{
			target = $(target).parent();
		}

		if(!$(target).parent().hasClass("treeview menuItem"))
		{
			return;
		}

		var _label = $(target).attr("data-formLabel");
		var _formId = $(target).attr("data-formId");
		var _menuItemId = $(target).attr("data-menuItemId");
		var _onlyQuery=$(target).attr("data-onlyQuery") == "true"?true:false;
		FormLoadHelper.openMenuItem({menuItemId:_menuItemId,onlyQuery:_onlyQuery,label:_label,checkHas:false,fromMainMenu:true});
	}

	//click
	menuItemClickSelect(event)
	{
		var target = event.target;
		$("#mainMenu a.selected").removeClass("selected");
		$(target).addClass("selected");
	}

	getLabelName(item){
		var label=GOTUtil.getPropertyValue(item,"Label");
      	if(label==""|!label){
      		label=item.name;
      	}
      	return label;
	}

	

	renderSub(items,moudleId,parent,isActive)
	{	
		var content=[];
		
		if(items)
		{	
			for(var i=0;i<items.length;i++)
			{
				var item = items[i];
				//item.pId = parent.id;
      			if(item.qname)
      			{
      				if(item.qname=="MenuItem")
      				{	
      					
						var isShow=false;   
      					var onlyQuery=false;
						var visible=item.Properties.Visible.V;
						if(!window.flatMainMenuToMenuItem.hasOwnProperty(item.id))
						{
							window.flatMainMenuToMenuItem[item.id] = {};
						}
						let _menuKey = moudleId+'.'+item.idInMenu;
						window.flatMainMenuToMenuItem[item.id][_menuKey] = true;
      					if(visible!='false')
      					{
							  if(window.userInfos.isAdmin)
							  {
								isShow = true;
							  }
							  else
							  {
	      						var thisAu=moudleId+'.'+item.idInMenu;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr)
	      						{
									if(!authorityArr.del && !authorityArr.visible && !authorityArr.query)
									{
										onlyQuery = true;
									}
									else if(!authorityArr.del && authorityArr.query)
									{
										isShow = true;onlyQuery = true;
									}
									else if(authorityArr.del || authorityArr.query)
									{
										isShow = true;
									}
				      			}
				      		}
      					}
      					var label=this.getLabelName(item);
      					
	      				if(isShow)
	      				{
							
							var _clsName = "iconfont icon-yingyong-dianjihou";
							var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
							if(iconPro)
							{
								_clsName = iconPro;
							}
							else
							{
								var icon_res_clsName = " menuItemIconCls_"+item.name;
								_clsName+=icon_res_clsName;
							}
								
							let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
	      					content.push(
	      						<li className="treeview menuItem" key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
									<a className="treeviewmenuItemA" title={label}  onClick={this.menuItemClickSelect.bind(this)} onDoubleClick={this.menuItemClick.bind(this)} data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={onlyQuery}>
										<i className={_clsName}></i> 
										<div >{label}</div>
	      							</a>
	      						</li>
	      					);
	      					let menuItemKey = item.id+"."+item.idInMenu;
	      					item.onlyQuery = onlyQuery;
	      					this.platMainMenu[menuItemKey] = item;
	      				}

      					
      				}else if(item.qname=="MenuSub")
      				{	
      					
      					var isShow=false; 
      					var visible=item.Properties.Visible.V;
      					if(visible=='true'){
      						if(window.userInfos.isAdmin){
	      						isShow=true;
	      					} else{
	      						var thisAu=moudleId+'.'+item.id;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	      								isShow=false;
	      							}else{
	      								isShow=true;
	      							}
	      						}
	      					}
      					}
      					
      					
						  if(isShow)
						  {
							var label=this.getLabelName(item);
							var _clsName = "fa fa-bars  treeviewMenuSubI";
							var iconPro = GOTUtil.getPropertyValue(item,"Icon");
							if(iconPro)_clsName = iconPro+" treeviewMenuSubI";
							var liClassNameSub = "treeview menuSub"
							if(isActive){
								liClassNameSub = "treeview menuSub active";
							}
      						content.push(
      						<li className={liClassNameSub} key={'menuSub-li'+i}>
								<a >
								<i className={_clsName} ></i> 
								<span>{label}</span>
								<span className="pull-right-container">
								<i className="fa fa-angle-left pull-right"></i>
								</span>
								</a>
								<ul className="treeview-menu">
								{this.renderSub(item.items,moudleId,item,isActive)}
      						</ul>
      						</li>
      						);
      					}

      				}
      			}
      			else
      			{	
      				var isShow=false; 
      				var visible=item.Properties.Visible.V;
      				if(visible=='true'){
      					if(window.userInfos.isAdmin){
		      				isShow=true;
		      			}else{
		      				moudleId=item.id; 
			      			var authorityArr=window.xmlType0SCache[moudleId];
			      			if(authorityArr){
			      				if(authorityArr.del){
			      					isShow=true;
			      				}else{
			      					isShow=false;
			      				}
			      			}
		      			}
      				}
      				
      				var label=this.getLabelName(item);
      				if(isShow){
						var _clsName = "fa fa-th-list";
						var iconPro = GOTUtil.getPropertyValue(item,"Icon");
						if(iconPro)_clsName = iconPro;
						let itemClassId =item.id.replace(/\./g, "_");;
						var liClassName = "treeview " +itemClassId;
						if(isActive){
							liClassName = "treeview  active  " +itemClassId;
						}
      					content.push(
      					<li className={liClassName} key={'treeview'+i}>
      					<a >
      					<i className={_clsName}></i> 
      					<span>{label}</span>
      					<span className="pull-right-container">
      					<i className="fa fa-angle-left pull-right"></i>
      					</span>
      					</a>
      					<ul className="treeview-menu">
      					{this.renderSub(item.items,moudleId,item,isActive)}
      					</ul>
      					</li>
      					);
      				}
      			}
			}
		}
		return content;
	}

	renderCustomMenu(mainContent)
	{
		if(!window.userSettingEntryOrig.menuCustomObject)
			return;
		let i = mainContent.length;
		if(i==0)
			return;
		let _menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
		let num = 0;
		for(let key in _menuCustomObject.customItems)
		{
			num++;
		}
		if(num == 0)return;
		mainContent.unshift(
			<li className="treeview" key={'treeview'+i}>
				<a >
					<i className="fa fa-user-plus"></i> 
					<span>常用菜单</span>
					<span className="pull-right-container">
						<i className="fa fa-angle-left pull-right"></i>
					</span>
				</a>
				<ul className="treeview-menu">
					{this.renderCustomMenuSub()}
				</ul>
			</li>
      	);
	}

	renderCustomMenuSubSub(groupKey,groupItem)
	{
		let content = [];let i = 0;
		if(!groupKey)
			return content;
		for(let key in window.userSettingEntryOrig.menuCustomObject.customItems)
		{
			let customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
			if(customItem.groupId != groupKey)
				continue;
			if(this.platMainMenu.hasOwnProperty(key))
			{
				let item = this.platMainMenu[key];
				var label=this.getLabelName(item);
				var _clsName = "iconfont icon-yingyong-dianjihou";
				var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
				if(iconPro)
				{
					_clsName = iconPro;
				}
				else
				{
					var icon_res_clsName = " menuItemIconCls_"+item.name;
					_clsName+=icon_res_clsName;
				}
				let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
				content.push(
					<li className="treeview menuItem" key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
						<a className='treeviewmenuItemA' title={label} onClick={this.menuItemClickSelect} onDoubleClick={this.menuItemClick} data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>
							<i className={_clsName} ></i> 
							<div >{label}</div>
						</a>
					</li>
				);
				i++;
			}
		}
		return content;
	}

	renderCustomMenuSub()
	{
		let content = [];let i = 0;
		for(let groupKey in window.userSettingEntryOrig.menuCustomObject.groups)
		{
			var groupItem = window.userSettingEntryOrig.menuCustomObject.groups[groupKey];
			var label=groupItem.name;
			var _clsName = "fa fa-bars";
			//var iconPro = GOTUtil.getPropertyValue(item,"Icon");
			//if(iconPro)_clsName = iconPro;
			content.push(
				<li className="treeview menuSub">
					<a >
						<i className={_clsName} ></i> 
						<span>{label}</span>
						<span className="pull-right-container">
							<i className="fa fa-angle-left pull-right"></i>
						</span>
					</a>
					<ul className="treeview-menu">
						{this.renderCustomMenuSubSub(groupKey,groupItem)}
					</ul>
				</li>
			);
		}

		for(let key in window.userSettingEntryOrig.menuCustomObject.customItems)
		{
			let customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
			if(customItem.groupId)continue;
			if(this.platMainMenu.hasOwnProperty(key))
			{
				let item = this.platMainMenu[key];
				var label=this.getLabelName(item);
				var _clsName = "iconfont icon-yingyong-dianjihou";
				var iconPro = GOTUtil.getPropertyValue(item,"Icon")  || GOTUtil.getPropertyValue(item,"HelpText");
				if(iconPro)
				{
					_clsName = iconPro;
				}
				else
				{
					var icon_res_clsName = " menuItemIconCls_"+item.name;
					_clsName+=icon_res_clsName;
				}
				let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
				content.push(
					<li className="treeview menuItem" key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
						<a className='treeviewmenuItemA' title={label}  onClick={this.menuItemClickSelect} onDoubleClick={this.menuItemClick} data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>
							<i ></i> 
							<div >{label}</div>
						</a>
					</li>
				);
				i++;
			}
		}
		return content;
	}
	rederUserDataSettings(mainContent,dataSettings,index){

		let i = mainContent.length;
		if(i==0)
			return;
		mainContent.unshift(
			<li className="treeview" key={'treeview'+(index+1)}>
				<a >
					<i className="iconfont icon-kaoheweidufenxi useDataSeti" ></i> 
					<span>数据集</span>
					<span className="pull-right-container">
						<i className="fa fa-angle-left pull-right"></i>
					</span>
				</a>
				<ul className="treeview-menu">
					{dataSettings}
				</ul>
			</li>
		);
		}

	render()
	{
		let mainMenu=this.props.data;  //[<li></li><li></li>] content.push(<li></li>);this.props.tree
		let dataSettings = this.props.dataSettings;
		let moudleId;
		let isActive;
		if(mainMenu.items.length<=2){
			isActive = true;
		}else{
			isActive = false;
		}
		let mainContent=this.renderSub(mainMenu.items,moudleId,mainMenu,isActive);
		this.renderCustomMenu(mainContent);
		if(dataSettings){
			this.rederUserDataSettings(mainContent,dataSettings,mainMenu.items.length);
		}
		//TODO MainMenu的Label不显示 <li className="header">{mainMenu.Properties.Label.V}</li>
		//[<div></div><div></div>]
		return(
			<ul className="sidebar-menu" >
        		{mainContent}
        	</ul>
		);

    }
}






// WEBPACK FOOTER //
// ./src/components/menu/TreeViewMainMenu.js